
import DatatableV3 from '/src/components/pages/layouts/datatable/DatatableV3.vue'
import VSimpleDatatables from "/src/components/base/plugins/VSimpleDatatables.vue"
import {useHead} from '@vueuse/head'
import SidebarLayout from '../../layouts/SidebarLayout.vue'
import {computed, defineComponent, onMounted, reactive, ref} from "vue";
import {mapGetters, mapState} from "vuex";
import {useToggle} from "@vueuse/core";
import store, {actions, ActionTypes} from '../../store'

export default defineComponent({
  name: 'OrdersListDrops',
  components: {
    SidebarLayout,
    VSimpleDatatables

  },

  beforeRouteEnter() {
    store.dispatch(ActionTypes.FETCH_ORDERS);
  },
  onBeforeMount() {
    store.dispatch(ActionTypes.FETCH_ORDERS);
  },
  setup() {
    const siteData = reactive({
      title: `JB Drax Honoré Strategies`
    })
    useHead({
// Can be static or computed
      title: computed(() => siteData.title),
    })
    useToggle(false)
  },
  data() {
    return {
      LoggedIn: {
        LoggedIn: localStorage.isLoggedIn
      },
      orders_data: ActionTypes.FETCH_ORDERS
    }
  },
  computed: {
    ...mapState(['user', 'orders'])
  },

})
